import { TextField } from '@bingads-webui-react/fluent-controls';

import { withControlledRemainingCharsUnvalidated } from './with-controlled-remaining-chars-unvalidated';

export const ControlledRemainingCharsUnvalidatedTextField = withControlledRemainingCharsUnvalidated(TextField);
